import * as React from 'react';
import { SVGProps } from 'react';

const IconLayerBlueSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 12V3.5L4 3l5.5 1 2.5-.5h3v9l-2.5.5L7 12l-3 1-3-1Z"
      fill="var(--color-typo-normal)"
    />
    <path
      d="m4 2 5.495.99 2.2-.49H15V6h-1V3.5h-2l-2.495.511L8 3.736V6H7V3.554l-3-.547-2 .329V6H1V2.5L4 2Z"
      fill="var(--color-typo-primary)"
    />
    <path
      d="M4 7.993V5h1v2.826l2.008-.334L9.55 8H11V5h1v2.993l3-.493v1l-2.959.5h-2.59l-2.46-.492L4 9.007l-3-.499V7.5l3 .493Z"
      fill="var(--color-typo-primary)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m7 12 5.5.99 2.5-.49v1l-2.5.5L7 13l-3 1-3-1v-1l3 1 3-1Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconLayerBlueSizeS;
